import styled, { css } from 'styled-components/macro';
import Icon from './Icon';
import { arrowDown, arrowUp } from '../styles/utils';

export const CloseIcon = styled(Icon)`
  color: ${props => props.theme.black};
  && {
    fill: black;
  }
  position: absolute;
  top: 7px;
  right: 7px;
  width: 10px;
  margin: 0.6rem 0.3rem;
`;

export const TooltipContentDiv = styled.div`
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 71px;
  width: 174px;
  padding: 2rem;
  ${props => props.theme.defaultDropShadow};
  ${props => props.theme.tooltipRectangleDropShadow};
  svg {
    fill: black;
  }
  ${props =>
    props.direction === 'down' &&
    css`
      top: 60px;
      left: 50%;
      transform: translateX(-50%);
      ${arrowUp({ size: 12, color: 'white', left: '50%' })};
    `}
  ${props =>
    props.direction === 'up' &&
    css`
      bottom: 35px;
      left: -80px;
      ${arrowDown({ size: 12, color: 'white', left: '50%' })};
      ${props =>
    props.mobileRightEdge &&
        css`
          @media screen and (max-width: 767px) {
            right: -19px;
            left: unset;
            &::after {
              left: 85%;
            }
          }
        `}
    `}
    /* position needs to come after arrow */
    position: absolute;
`;

export const TooltipContentP = styled.p`
  color: ${props => props.theme.black};
  text-transform: none;
  word-break: break-word;
  white-space: initial;
  text-align: initial;
`;
